import { Injectable } from "@angular/core";
import { HomeDLServiceService } from "./home-dlservice.service";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HomeBLServiceService {
  constructor(public homeDLServiceService: HomeDLServiceService) {}

  //#region Home
  public getHomeDashboard() {
    return this.homeDLServiceService.getHomeDashboard().pipe(map((res) => res));
  }
  public getPatientDistributionChart() {
    return this.homeDLServiceService
      .getPatientDistributionChart()
      .pipe(map((res) => res));
  }
  public getVisitDistributionChart() {
    return this.homeDLServiceService
      .getVisitDistributionChart()
      .pipe(map((res) => res));
  }
  public getMedicalStatisticsChart() {
    return this.homeDLServiceService
      .getMedicalStatisticsChart()
      .pipe(map((res) => res));
  }
  public getPatientFlowStatus() {
    return this.homeDLServiceService
      .getPatientFlowStatus()
      .pipe(map((res) => res));
  }
  //#endregion
}
